import { apiClient } from "@lib/axios";
import type { IVersion } from "@/types";

const path = (path: string) => `/versions${path}`;

export const versionsApi = {
  searchVersions: async (params: {
    search: string;
    size: number;
    page: number;
    sort?: string;
    order?: string;
    userId?: string;
    pageIds?: string[];
    dateField?: "createdAt" | "updatedAt";
    dateFrom?: string;
    dateTo?: string;
    /** The caller's own opens; see SearchPagesParams.recentlyViewed. */
    recentlyViewed?: boolean;
    /** Comma-separated version statuses. */
    statuses?: string;
    /** Leave the stories' primary versions out of the page — see the query. */
    excludePrimary?: boolean;
  }) => {
    /**
     * Drops the params that carry nothing, and keeps every type that does.
     *
     * Booleans belong in that second group: `recentlyViewed` is one, and while
     * this filter passed only strings and numbers it was thrown away without a
     * word — the dashboard asked for its Recently viewed scope and the request
     * never carried the flag. The pages endpoint stringifies everything through
     * filterEmptyParams, which is why the same scope worked there and not here.
     */
    const filteredParams = Object.entries(params).reduce<
      Record<string, string | number | boolean | string[]>
    >((acc, [key, value]) => {
      if (value !== undefined) {
        // Keep pageIds as array for POST body
        if (key === "pageIds" && Array.isArray(value)) {
          acc[key] = value;
        } else if (
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        ) {
          acc[key] = value;
        }
      }
      return acc;
    }, {});

    return apiClient.post<IVersion[]>(path("/search"), filteredParams);
  },
};
